module.exports = __webpack_public_path__ + "static/media/account-background.deac6f9a.jpg";